import { router } from "./router";
var authRedirectKey = 'login_auth_redirect';
var PermissionMixin = {
    methods: {
        setAuthRedirect: function () {
            localStorage.setItem(authRedirectKey, router.currentRoute.path);
        },
        getAuthRedirect: function () {
            return localStorage.getItem(authRedirectKey);
        },
        clearAuthRedirect: function () {
            localStorage.removeItem(authRedirectKey);
        },
        handleError: function (error) {
            if (error.response && error.response.status === 401) {
                this.setAuthRedirect();
                return router.push({ name: 'login' });
            }
            if (error.response && error.response.status === 403) {
                return router.go(-1);
            }
        }
    }
};
var NavigationMixin = {
    methods: {
        goBack: function () {
            router.go(-1);
        },
    }
};
var FormattingMixin = {
    methods: {
        ellipsis: function (text, max) {
            if (text && text.length > max) {
                return text.substring(0, max) + '...';
            }
            return text;
        },
        formatDate: function (input) {
            var date = new Date(input);
            return new Intl.DateTimeFormat('en-GB', {
                timeStyle: 'short',
                dateStyle: 'full'
            }).format(date);
        },
        formatDateShort: function (input) {
            var date = new Date(input);
            return new Intl.DateTimeFormat('en-GB', {
                dateStyle: 'full'
            }).format(date);
        },
        formatCurrency: function (currency_code, value, locale) {
            if (locale === void 0) { locale = 'en-GB'; }
            var currencyFormat = function (currency) { return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }); };
            return currencyFormat(currency_code).format(value);
        },
        currencySymbol: function (currency_code) {
            var data = this.formatCurrency(currency_code, 0);
            return data.replace('0.00', '');
        },
    }
};
var HttpStatusMixin = {
    methods: {
        statusBox: function (status) {
            var formatted = status ? status.toLowerCase() : status;
            if ((status >= 100 && status < 200) || formatted === 'open') {
                return 'status-box status-open';
            }
            if ((status >= 200 && status < 300) || formatted === 'complete') {
                return 'status-box status-complete';
            }
            if ((status >= 300 && status < 400) || formatted === 'processing') {
                return 'status-box status-pending';
            }
            if ((status >= 300 && status < 400) || formatted === 'failed') {
                return 'status-box status-cancelled';
            }
            if ((status >= 400 && status < 500)) {
                return 'status-box status-action-required';
            }
            if ((status >= 500 && status < 600) || formatted === 'cancelled' || formatted === 'refunded') {
                return 'status-box status-cancelled';
            }
            return 'status-box bg-gray-100';
        },
        convertStatus: function (status) {
            var formatted = status ? status.toLowerCase() : status;
            var name = '';
            switch (formatted) {
                case '100':
                    name = 'Continue';
                    break;
                case '101':
                    name = 'Switching Protocols';
                    break;
                case '102':
                    name = 'Processing';
                    break;
                case '200':
                    name = 'OK';
                    break;
                case '201':
                    name = 'Created';
                    break;
                case '202':
                    name = 'Accepted';
                    break;
                case '203':
                    name = 'Non-authoritative Information';
                    break;
                case '204':
                    name = 'No Content';
                    break;
                case '205':
                    name = 'Reset Content';
                    break;
                case '206':
                    name = 'Partial Content';
                    break;
                case '207':
                    name = 'Multi-Status';
                    break;
                case '208':
                    name = 'Already Reported';
                    break;
                case '226':
                    name = 'IM Used';
                    break;
                case '300':
                    name = 'Multiple Choices';
                    break;
                case '301':
                    name = 'Moved Permanently';
                    break;
                case '302':
                    name = 'Found';
                    break;
                case '303':
                    name = 'See Other';
                    break;
                case '304':
                    name = 'Not Modified';
                    break;
                case '305':
                    name = 'Use Proxy';
                    break;
                case '307':
                    name = 'Temporary Redirect';
                    break;
                case '308':
                    name = 'Permanent Redirect';
                    break;
                case '400':
                    name = 'Bad Request';
                    break;
                case '401':
                    name = 'Unauthorized';
                    break;
                case '402':
                    name = 'Payment Required';
                    break;
                case '403':
                    name = 'Forbidden';
                    break;
                case '404':
                    name = 'Not Found';
                    break;
                case '405':
                    name = 'Method Not Allowed';
                    break;
                case '406':
                    name = 'Not Acceptable';
                    break;
                case '407':
                    name = 'Proxy Authentication Required';
                    break;
                case '408':
                    name = 'Request Timeout';
                    break;
                case '409':
                    name = 'Conflict';
                    break;
                case '410':
                    name = 'Gone';
                    break;
                case '411':
                    name = 'Length Required';
                    break;
                case '412':
                    name = 'Precondition Failed';
                    break;
                case '413':
                    name = 'Payload Too Large';
                    break;
                case '414':
                    name = 'Request-URI Too Long';
                    break;
                case '415':
                    name = 'Unsupported Media Type';
                    break;
                case '416':
                    name = 'Requested Range Not Satisfiable';
                    break;
                case '417':
                    name = 'Expectation Failed';
                    break;
                case '418':
                    name = 'I\'m a teapot';
                    break;
                case '421':
                    name = 'Misdirected Request';
                    break;
                case '422':
                    name = 'Unprocessable Entity';
                    break;
                case '423':
                    name = 'Locked';
                    break;
                case '424':
                    name = 'Failed Dependency';
                    break;
                case '426':
                    name = 'Upgrade Required';
                    break;
                case '428':
                    name = 'Precondition Required';
                    break;
                case '429':
                    name = 'Too Many Requests';
                    break;
                case '431':
                    name = 'Request Header Fields Too Large';
                    break;
                case '444':
                    name = 'Connection Closed Without Response';
                    break;
                case '451':
                    name = 'Unavailable For Legal Reasons';
                    break;
                case '499':
                    name = 'Client Closed Request';
                    break;
                case '500':
                    name = 'Server Error';
                    break;
                case '501':
                    name = 'Not Implemented';
                    break;
                case '502':
                    name = 'Bad Gateway';
                    break;
                case '503':
                    name = 'Service Unavailable';
                    break;
                case '504':
                    name = 'Gateway Timeout';
                    break;
                case '505':
                    name = 'HTTP Version Not Supported';
                    break;
                case '506':
                    name = 'Variant Also Negotiates';
                    break;
                case '507':
                    name = 'Insufficient Storage';
                    break;
                case '508':
                    name = 'Loop Detected';
                    break;
                case '510':
                    name = 'Not Extended';
                    break;
                case '511':
                    name = 'Network Authentication Required';
                    break;
                case '599':
                    name = 'Network Connect Timeout Error';
                    break;
            }
            return status + ' ' + name;
        }
    }
};
export { authRedirectKey, PermissionMixin, NavigationMixin, FormattingMixin, HttpStatusMixin };
